export default __webpack_public_path__ + "static/w3-86d5db08b434cb77e49af24cb5f69023.webp";